import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "logic-builder"
};
const _hoisted_2 = {
  class: "builder-header"
};
const _hoisted_3 = {
  key: 0,
  class: "channel-name"
};
const _hoisted_4 = {
  key: 0,
  class: "formula-preview"
};
const _hoisted_5 = {
  key: 1,
  class: "channel-conditions"
};
const _hoisted_6 = {
  key: 2,
  class: "divider"
};
const _hoisted_7 = {
  key: 3,
  class: "props-container"
};
const _hoisted_8 = {
  class: "props-stat"
};
const _hoisted_9 = {
  class: "props-rare-stat"
};
const _hoisted_10 = {
  key: 0,
  class: "pagination-container"
};
const _hoisted_11 = {
  class: "pagination-container"
};
import { ref, computed, onMounted, watch } from 'vue';
import { ElButton, ElInput, ElPagination, ElSelect, ElSwitch } from 'element-plus';
import JsonEditorVue3 from 'json-editor-vue3';
import store from '@/store';
import { request } from '@/manager/net_manager';
import { getPropsRareLevelDesc, isAdminType } from '@/tools/utils';
export default {
  __name: 'ChannelCard',
  props: {
    channel: {
      type: Object,
      required: true
    },
    models: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update-channel', 'update-props', 'remove-channel'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const editorOptions = {
      mode: 'code',
      mainMenuBar: false,
      enableSort: false,
      enableTransform: false,
      language: 'zh-CN',
      schema: {
        type: 'object',
        properties: {
          qualification_logic: {
            type: 'object'
          }
        }
      }
    }; // refs

    const localChannel = ref(null);
    const editMode = ref(false);
    const propsManageMode = ref(false);
    const model = ref(null);
    const organization = ref(null);
    const qualification = ref(null);
    const addPropsIds = ref([]);
    const dataArray = ref([]);
    const pagerCount = ref(5);
    const size = ref(20);
    const marketPropsTotal = ref(0);
    const marketPropsPage = ref(0);
    const cacheMarketProps = ref({}); // computed

    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    });
    const generatedFormula = computed(() => {
      return formatFormula(localChannel.value.qualification_logic);
    });
    const worldOutlook = computed(() => store.state.world_outlook || null);
    const organizations = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.organizations ?? null;
    });
    const qualifications = computed(() => {
      if (!worldOutlook.value) return null;
      return store.state.world_outlook_info[worldOutlook.value.id]?.qualifications ?? null;
    });
    const addProps = computed(() => {
      const buffer = [...Object.values(cacheMarketProps.value).flat(), localChannel.value.props];
      return buffer.filter(item => addPropsIds.value.includes(item.id));
    });
    const propsRareStat = computed(() => {
      const rareDict = {};

      for (let i = 0; i < 5; i++) {
        rareDict[getPropsRareLevelDesc(i)] = 0;
      }

      localChannel.value.props.forEach(item => {
        let key = getPropsRareLevelDesc(item['rare_level']);

        if (Object.keys(rareDict).includes(key)) {
          rareDict[key] = rareDict[key] + 1;
        }
      });
      const rareDictDesc = Object.entries(rareDict).map(([key, value]) => {
        return `${key} ${value}`;
      }).join(' ｜ ');
      return rareDictDesc;
    }); // functions

    function formatFormula(logic) {
      if (!logic || !logic.conditions || logic.conditions.length === 0) {
        return '无条件限制';
      }

      const operator = logic.logic_type === 'AND' ? '且' : '或';
      const conditions = logic.conditions.map(cond => {
        if (cond.type === 'SINGLE') {
          let desc = `${cond.model}满足`;

          if (cond.specific_fields && Object.keys(cond.specific_fields).length > 0) {
            const fields = Object.entries(cond.specific_fields).map(([k, v]) => `${k}-->${v}`).join(', ');
            desc += `(${fields})`;
          }

          return desc;
        } else if (cond.type === 'GROUP') {
          const groupOperator = cond.operator === 'AND' ? '且' : '或';
          const groupConditions = cond.conditions.map(c => formatFormula({
            logic_type: cond.operator,
            conditions: [c]
          })).join(` ${groupOperator} `);
          return `${groupConditions}`;
        }

        return '';
      }).join(` ${operator} `);
      return `${conditions}`;
    }

    const submitChannel = () => {
      emits('update-channel', localChannel.value);
      editMode.value = false;
    };

    const submitChannelProps = () => {
      emits('update-props', {
        'id': props.channel.id,
        'props': addPropsIds.value
      });
      propsManageMode.value = false;
    };

    const removeChannel = () => {
      emits('remove-channel', localChannel.value);
      editMode.value = false;
    };

    const getMarketProps = () => {
      if (worldOutlook.value) {
        let parameters = {
          'world_outlook_id': worldOutlook.value.id,
          'exclude_channel_id': props.channel.id,
          'page': marketPropsPage.value,
          'size': size.value
        };
        request('props/market_props/list/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            cacheMarketProps.value[parameters.page] = response.data.props;
            marketPropsTotal.value = response.data.numbers;
            setupDataArray();
          }
        });
      }
    };

    const setupDataArray = () => {
      let buffer = [...addProps.value, ...localChannel.value.props]; // console.log(JSON.stringify(cacheMarketProps.value))
      // console.log(JSON.stringify(marketPropsPage.value))

      if (Object.keys(cacheMarketProps.value).includes(marketPropsPage.value.toString())) {
        let pageProps = cacheMarketProps.value[marketPropsPage.value.toString()];
        let existsPropsIds = buffer.map(item => item.id);
        pageProps = pageProps.filter(item => !existsPropsIds.includes(item.id));
        buffer = [...buffer, ...pageProps];
      }

      dataArray.value = buffer;
    }; // const handlePropsChange = (value, direction, movedKeys) => {
    //   console.log(value, direction, movedKeys)
    // }


    const handlePageChange = index => {
      marketPropsPage.value = index - 1;

      if (!Object.keys(cacheMarketProps.value).includes(marketPropsPage.value)) {
        getMarketProps();
      } else {
        setupDataArray();
      }
    }; // lifecycle


    onMounted(() => {
      // console.log(JSON.stringify(props.channel))
      localChannel.value = props.channel;
    }); // watcher

    watch(() => propsManageMode.value, newValue => {
      if (newValue) {
        cacheMarketProps.value = {};
        addPropsIds.value = localChannel.value.props.map(item => item.id);
        handlePageChange(1);
      }
    });
    watch(() => props.channel, newValue => {
      localChannel.value = newValue;
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_transfer = _resolveComponent("el-transfer");

      return localChannel.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!editMode.value ? (_openBlock(), _createElementBlock("text", _hoisted_3, _toDisplayString(localChannel.value.name && localChannel.value.name.length > 0 ? localChannel.value.name : '未命名渠道'), 1)) : (_openBlock(), _createBlock(_unref(ElInput), {
        key: 1,
        modelValue: localChannel.value.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => localChannel.value.name = $event),
        maxlength: "128",
        clearable: "",
        "show-word-limit": "",
        placeholder: "渠道名称"
      }, null, 8, ["modelValue"])), _withDirectives(_createVNode(_unref(ElSwitch), {
        modelValue: editMode.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editMode.value = $event),
        "active-text": editMode.value ? '修改' : '',
        "inactive-text": editMode.value ? '' : '预览',
        "inline-prompt": ""
      }, null, 8, ["modelValue", "active-text", "inactive-text"]), [[_vShow, _unref(isAdminType)(userType.value)]])]), _cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), !editMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("text", null, _toDisplayString(generatedFormula.value), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_unref(ElSelect), {
          modelValue: model.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => model.value = $event),
          "show-arrow": false,
          clearable: "",
          placeholder: "查询模型",
          "popper-class": "commonPopper",
          class: _normalizeClass(model.value ? 'selected-selector' : '')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.models, (item, index) => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item,
              value: item
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "class"]), _createVNode(_unref(ElSelect), {
          modelValue: organization.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => organization.value = $event),
          "show-arrow": false,
          clearable: "",
          placeholder: "查询WO组织",
          "popper-class": "commonPopper",
          class: _normalizeClass(organization.value ? 'selected-selector' : '')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organizations.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: `${item.id} - ${item.name}`,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "class"]), _createVNode(_unref(ElSelect), {
          modelValue: qualification.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => qualification.value = $event),
          "show-arrow": false,
          clearable: "",
          placeholder: "查询WO资格",
          "popper-class": "commonPopper",
          class: _normalizeClass(qualification.value ? 'selected-selector' : '')
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qualifications.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: `${item.id} - ${item.name}`,
              value: item.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "class"])]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_unref(JsonEditorVue3), {
          modelValue: localChannel.value.qualification_logic,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => localChannel.value.qualification_logic = $event),
          options: editorOptions
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_unref(ElButton), {
          class: "remove-channel",
          onClick: removeChannel
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 删除该渠道 ", -1)]))]),
          _: 1
        }, 512), [[_vShow, _unref(isAdminType)(userType.value)]]), _createVNode(_unref(ElButton), {
          onClick: submitChannel
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" 更新渠道设定 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })])), !editMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_6)) : _createCommentVNode("", true), !editMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_row, {
        class: "props-stat-container"
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_8, _toDisplayString(localChannel.value.props?.length ?? 0) + " 件登记商品 ", 1), _withDirectives(_createVNode(_unref(ElSwitch), {
          modelValue: propsManageMode.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => propsManageMode.value = $event),
          "active-text": propsManageMode.value ? '管理' : '',
          "inactive-text": propsManageMode.value ? '' : '预览',
          "inline-prompt": ""
        }, null, 8, ["modelValue", "active-text", "inactive-text"]), [[_vShow, _unref(isAdminType)(userType.value)]])]),
        _: 1
      }), !propsManageMode.value ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, null, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "props-stat-container"
          }, {
            default: _withCtx(() => [_createElementVNode("text", _hoisted_9, _toDisplayString(propsRareStat.value), 1)]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localChannel.value.props, item => {
              return _openBlock(), _createBlock(_component_el_tag, {
                key: item.id,
                value: item.id
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["value"]);
            }), 128))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_row, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_el_transfer, {
          modelValue: addPropsIds.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => addPropsIds.value = $event),
          data: dataArray.value,
          props: {
            key: 'id',
            label: 'name'
          },
          filterable: "",
          titles: ['市场道具', '渠道道具']
        }, {
          "left-footer": _withCtx(() => [marketPropsTotal.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_unref(ElPagination), {
            "page-size": size.value,
            "pager-count": pagerCount.value,
            layout: "prev, pager, next",
            total: marketPropsTotal.value,
            background: true,
            onChange: handlePageChange
          }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]),
          "right-footer": _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(ElButton), {
            onClick: submitChannelProps
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("记录道具变更", -1)]))]),
            _: 1
          })])]),
          _: 1
        }, 8, ["modelValue", "data"])]),
        _: 1
      }))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};